"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = (e = require("react")) && "object" == typeof e && "default" in e ? e["default"] : e,
    r = require("@vx/responsive"),
    i = require("@vx/shape"),
    n = require("@vx/group"),
    a = require("@vx/scale"),
    o = require("@vx/text"),
    l = require("@vx/pattern");

function d() {
  return (d = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var i in r) {
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function h(e, t) {
  if (null == e) return {};
  var r,
      i,
      n = {},
      a = Object.keys(e);

  for (i = 0; i < a.length; i++) {
    t.indexOf(r = a[i]) >= 0 || (n[r] = e[r]);
  }

  return n;
}

var s = function s() {
  return null;
};

function c(e) {
  var l = e.bg,
      c = e.barText,
      u = h(e, ["bg", "barText"]);
  return t.createElement(r.ParentSize, null, function (e) {
    var r = u.data.reduce(function (e, t) {
      return e.row[t.key] = t.value, e.stackKeys.push(t.key), e.fills.push(t.fill), e.total += +t.value, e;
    }, {
      row: {},
      stackKeys: [],
      fills: [],
      total: 0
    }),
        h = r.stackKeys,
        v = r.fills,
        g = [r.row],
        f = u.width || e.width,
        p = u.height || e.height;
    if (f < 10) return null;
    var k = a.scaleLinear({
      domain: [0, r.total]
    }),
        x = a.scaleBand({
      domain: g.map(s),
      padding: 0
    }),
        m = a.scaleOrdinal({
      domain: h,
      range: v
    }),
        w = p;
    return k.rangeRound([0, f]), x.rangeRound([w, 0]), t.createElement("div", {
      style: {
        position: "relative"
      }
    }, t.createElement("svg", {
      width: f,
      height: p,
      "data-testid": "BarStackHorizontalSimple__Svg"
    }, t.createElement("rect", {
      width: f,
      height: p,
      fill: l
    }), t.createElement(n.Group, null, t.createElement(i.BarStackHorizontal, {
      data: g,
      keys: h,
      height: w,
      y: s,
      xScale: k,
      yScale: x,
      color: m
    }, function (e) {
      return e.map(function (e) {
        return e.bars.map(function (r) {
          var i = c && c(d({}, r, {
            index: e.index
          }));
          return t.createElement("g", {
            key: "barstack-horizontal-" + e.index + "-" + r.index
          }, t.createElement("rect", {
            x: r.x,
            y: r.y,
            width: r.width,
            height: r.height,
            fill: r.color
          }), i && t.createElement(o.Text, Object.assign({
            verticalAnchor: "middle",
            fontSize: 9,
            textAnchor: "middle",
            x: r.x + r.width / 2,
            y: r.y + r.height / 2,
            width: r.width,
            height: r.height
          }, i)));
        });
      });
    }))));
  });
}

c.defaultProps = {
  bg: "white"
}, exports.BarStackHorizontalSimple = c, exports.PatternCircles = function (e) {
  var r = e.id,
      i = void 0 === r ? "pattern-circles" : r,
      n = e.stroke,
      a = void 0 === n ? "black" : n,
      o = e.width,
      d = void 0 === o ? 4 : o,
      s = e.height,
      c = void 0 === s ? 4 : s,
      u = e.strokeWidth,
      v = void 0 === u ? 2 : u,
      g = h(e, ["id", "stroke", "width", "height", "strokeWidth"]);
  return t.createElement(l.PatternCircles, Object.assign({
    id: i,
    height: c,
    width: d,
    stroke: a,
    strokeWidth: v
  }, g));
}, exports.PatternLines = function (e) {
  var r = e.id,
      i = void 0 === r ? "pattern-lines" : r,
      n = e.orientation,
      a = void 0 === n ? ["diagonal"] : n,
      o = e.stroke,
      d = void 0 === o ? "black" : o,
      s = e.width,
      c = void 0 === s ? 5 : s,
      u = e.height,
      v = void 0 === u ? 5 : u,
      g = e.strokeWidth,
      f = void 0 === g ? 1 : g,
      p = h(e, ["id", "orientation", "stroke", "width", "height", "strokeWidth"]);
  return t.createElement(l.PatternLines, Object.assign({
    id: i,
    height: v,
    width: c,
    stroke: d,
    strokeWidth: f,
    orientation: a
  }, p));
};